/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Codeeditor_Press_To_Save_PrefixInputs */



/**
* | output |
* | --- |
* | "Press" |
*
* @param {Spaces_Codeeditor_Press_To_Save_PrefixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_codeeditor_press_to_save_prefix = /** @type {((inputs?: Spaces_Codeeditor_Press_To_Save_PrefixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Codeeditor_Press_To_Save_PrefixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Drücken Sie")
	return /** @type {LocalizedString} */ ("Press")
});